<div class="main-container" style="background-color: #ffffff;">
  <div #transactionPage class="container transaction-page-container" style="background-color: #ffffff; margin-top: 10px;">
    <div class="row transaction-filter-row">
      <div class="col-6 col-md-4 form-group transaction-date-filter" [ngClass]="{'mt-2': isMobile}">
        <label for="transaction-start-date" class="fieldName" style="font-size: 12px;">START DATE</label>
        <div class="input-group">
          <input id="transaction-start-date" type="date" [(ngModel)]="selectedStartDateStr" class="form-control" placeholder="Select Date"
            value="{{selectedStartDateStr}}" name="selectedStartDate" (change)="onStartDateChange($event.target.value)">
        </div>
      </div>
      <div class="col-6 col-md-4 form-group transaction-date-filter" [ngClass]="{'mt-2': isMobile}">
        <label for="transaction-end-date" class="fieldName" style="font-size: 12px;">END DATE</label>
        <div class="input-group">
          <input id="transaction-end-date" type="date" [(ngModel)]="selectedEndDateStr" class="form-control" placeholder="Select Date"
            value="{{selectedEndDateStr}}" name="selectedEndDate" (change)="onEndDateChange($event.target.value)">
        </div>
      </div>
      <button type="button" class="btn date-search-button" title="Search date range" aria-label="Search date range" (click)="search()">
        <i class="fa fa-search" aria-hidden="true"></i>
      </button>
      <div class="col-12 col-md-4 form-group search-group" [ngClass]="{'mt-2': isMobile}">
        <label class="fieldName" style="font-size: 12px;">SEARCH</label>
        <div class="search-controls">
          <input type="text" [(ngModel)]="searchText" placeholder="Enter Booking ID" aria-label="Booking ID" class="form-control" (keyup.enter)="search()">
          <button class="btn btn-primary book-now-btn" (click)="search()">Search</button>
        </div>
      </div>
    </div>
    <p *ngIf="dateRangeError" class="text-danger" role="alert">{{dateRangeError}}</p>
    <div *ngIf="isLoading" class="text-center py-5" role="status" aria-label="Loading transactions">
      <span class="spinner-border" aria-hidden="true"></span>
    </div>
    <div #transactionResults class="row transaction-results" [class.transactions-loading]="isLoading">
      <div class="col transaction-table">
        <div class="table-container" *ngIf="roleId !== 3">
          <table mat-table [dataSource]="data" class="example-table" matSort *ngIf="this.roleId !== 3" >
          <ng-container matColumnDef="bookingId">
            <th mat-header-cell *matHeaderCellDef>Booking ID</th>
            <td mat-cell *matCellDef="let row">{{row.bookingId}}</td>
          </ng-container>

          <ng-container matColumnDef="customer">
            <th mat-header-cell *matHeaderCellDef>Customer</th>
            <td mat-cell *matCellDef="let row">{{row.userName}}</td>
          </ng-container>

          <ng-container matColumnDef="date">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
            <td mat-cell *matCellDef="let row">{{getFormattedDateWithTime(row.bookingDateTime)}}</td>
          </ng-container>

          <ng-container matColumnDef="amount">
            <th mat-header-cell *matHeaderCellDef>Amount</th>
            <td mat-cell *matCellDef="let row">{{row.netAmount | number:'1.2-2'}}</td>
          </ng-container>

          <ng-container matColumnDef="payment">
            <th mat-header-cell *matHeaderCellDef>Payment</th>
            <td mat-cell *matCellDef="let row" [style.color]="getStatusColor(row.paymentStatus)" >{{formatPaymentStatus(row.paymentStatus)}}</td>
          </ng-container>

          <ng-container matColumnDef="phone">
            <th mat-header-cell *matHeaderCellDef>Phone</th>
            <td mat-cell *matCellDef="let row">{{row.userPhone}}</td>
          </ng-container>

          <ng-container matColumnDef="booking">
            <th mat-header-cell *matHeaderCellDef>
              Booking
            </th>
            <td mat-cell *matCellDef="let row" [style.color]="getStatusColor(row.bookingStatus)" >{{row.bookingStatus}}</td>
          </ng-container>
          <ng-container matColumnDef="endDate">
            <th mat-header-cell *matHeaderCellDef>
              END DATE
            </th>
            <td mat-cell *matCellDef="let row">
              {{ row.endDate ? (row.endDate | date:'dd MMM yyyy') : '-' }}
            </td>
            <!--<td mat-cell *matCellDef="let row">{{row.bookingEndDate}}</td>-->
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="onRowClicked(row)"></tr>
        </table>
        </div>

        <mat-paginator #paginator [length]="resultsLength"
                        [pageSizeOptions]="[20,50,100]"
                        [showFirstLastButtons]="true" [pageSize]="this.pageSize" *ngIf="this.roleId !== 3"></mat-paginator>

        <div class="transactionGrid" *ngIf="this.roleId == 3">
          <ag-grid-angular class="ag-theme-alpine" [rowData]="rowData"
            [columnDefs]="gridOptions.columnDefs" (gridReady)="onGridReady($event)" (rowClicked)="onRowClicked($event)"
            [gridOptions]="gridOptions">
          </ag-grid-angular>
        </div>
      </div>
    </div>
  </div>

  <div #bookingDetailsModal class="modal fade booking-details-modal" id="transactionBookingDetailsModal">
    <div class="modal-dialog modal-md modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content">

        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title descriptionHeader">Booking Details</h4>
          <!--<button type="button" class="pop-up-btn-white" *ngIf="bookingStatus === 'Booked'" (click)="cancelBooking()">Cancel Booking</button>-->
        </div>
        <!-- Modal body -->
        <div class="modal-body" tabindex="0" role="region" aria-label="Booking details">
          <div class="row">
            <div class="col-md-12">
              <div>
                <h6 class="descriptionHeader" style="margin-top:10px; font-size: 0.9rem;">CUSTOMER</h6>
                <table class="table table-borderless transaction-details-table">
                  <tr>
                    <td class="bookedSlotsFieldName">NAME</td>
                    <td class="bookedSlotsFieldValue">{{userName}}</td>
                  </tr>
                  <tr>
                    <td class="bookedSlotsFieldName">EMAIL ID</td>
                    <td class="bookedSlotsFieldValue">{{userEmail}}</td>
                  </tr>
                  <tr>
                    <td class="bookedSlotsFieldName">PHONE NO</td>
                    <td class="bookedSlotsFieldValue">{{userPhone}}</td>
                  </tr>
                </table>
                <h6 class="descriptionHeader" style="margin-top:10px;font-size: 0.9rem;">DETAILS</h6>
                <table class="table table-borderless transaction-details-table">
                  <tr>
                    <td class="bookedSlotsFieldName">BOOKING ID</td>
                    <td class="bookedSlotsFieldValue">{{bookingId}}</td>
                  </tr>
                  <tr>
                    <td class="bookedSlotsFieldName">BOOKING DATE</td>
                    <td class="bookedSlotsFieldValue">{{bookingDateTime}}</td>
                  </tr>
                  <tr *ngIf="endDate">
                    <td class="bookedSlotsFieldName">BOOKING END DATE</td>
                    <td class="bookedSlotsFieldValue">
                      {{ endDate }}
                    </td>
                  </tr>
                  <tr>
                    <td class="bookedSlotsFieldName">STATUS</td>
                    <td *ngIf="bookingStatus === 'Booked'" class="bookedSlotsFieldValue transaction-status" style="color: green;">{{bookingStatus}}</td>
                    <td *ngIf="bookingStatus === 'Failed'" class="bookedSlotsFieldValue transaction-status" style="color: red;">{{bookingStatus}}</td>
                    <td *ngIf="bookingStatus === 'WaitingForPayment'" class="bookedSlotsFieldValue transaction-status" style="color: orange;">{{bookingStatus}}</td>
                    <td *ngIf="bookingStatus === 'Cancelled'" class="bookedSlotsFieldValue transaction-status" style="color: red;">{{bookingStatus}}</td>
                  </tr>

                  <tr *ngIf="discountAmount > 0 || totalPlatformFeeEndUser > 0">
                    <td class="bookedSlotsFieldName">SUBTOTAL</td>
                    <td class="bookedSlotsFieldValue">{{totalAmount | number:'1.2-2'}}</td>
                  </tr>
                  <tr *ngIf="discountAmount > 0">
                    <td class="bookedSlotsFieldName">DISCOUNT</td>
                    <td class="bookedSlotsFieldValue" style="color: green;">- {{discountAmount | number:'1.2-2'}}</td>
                  </tr>
                  <tr *ngIf="totalPlatformFeeEndUser > 0">
                    <td class="bookedSlotsFieldName">PLATFORM FEE (END USER)</td>
                    <td class="bookedSlotsFieldValue">{{totalPlatformFeeEndUser | number:'1.2-2'}}</td>
                  </tr>
                  <tr>
                    <td class="bookedSlotsFieldName">TOTAL AMOUNT</td>
                    <td class="bookedSlotsFieldValue">{{netAmount | number:'1.2-2'}}</td>
                  </tr>
                  <tr>
                    <td class="bookedSlotsFieldName">PAYMENT STATUS</td>
                    <td class="bookedSlotsFieldValue transaction-status">{{formatPaymentStatus(paymentStatus)}}</td>
                  </tr>
                  <tr>
                    <td class="bookedSlotsFieldName">PAYMENT TYPE</td>
                    <td class="bookedSlotsFieldValue">{{paymentType}}</td>
                  </tr>
                  <tr>
                    <td class="bookedSlotsFieldName">TRANSACTION ID</td>
                    <td class="bookedSlotsFieldValue">{{transactionId}}</td>
                  </tr>
                  <tr *ngIf="selectedDays.length > 0">
                    <td class="bookedSlotsFieldName">DAYS</td>
                    <div class="bookedSlotsFieldValue">
                      <mat-chip-listbox [disabled]="true" multiple>
                        <mat-chip-option
                          *ngFor="let chip of productEditAddSessionChips"
                          [value]="chip"
                          [selected]="selectedDays.includes(chip)">
                          {{ chip.charAt(0).toUpperCase() }}
                        </mat-chip-option>
                      </mat-chip-listbox>

                    </div>
                  </tr>
                  <!--<tr>
                    <td class ="bookedSlotsFieldName">TRANSACTION TIME </td>
                    <td class ="bookedSlotsFieldValue">Need to store</td>
                  </tr>-->
                  <tr>
                    <td class="bookedSlotsFieldName">NOTES</td>
                    <td class="bookedSlotsFieldValue">{{notes}}</td>
                  </tr>
                  <tr>
                    <td class="bookedSlotsFieldName">BOOKED BY</td>
                    <td class="bookedSlotsFieldValue">{{bookedBy}}</td>
                  </tr>
                </table>
                <h6 class="descriptionHeader" style="margin-top:10px;font-size: 0.9rem;" *ngIf="(slotsBooked | keyvalue).length > 0">SLOTS</h6>
                <div *ngFor="let slot of slotsBooked | keyvalue; let i = index" style="margin-top: 20px;">
                  <div class="row bookedSlotsVenueProduct" style="font: bold;">
                    <div class="slot-product">
                      <p>{{slot.value[0].productName}} : </p>
                    </div>
                    <div class="slot-venue">
                      <p  class="slot-item" >{{slot.value[0].venueName}}</p>
                    </div>
                    <div class="button-container" *ngIf="canDeleteSlot(slot.value[0])">
                      <button type="button" class="delete-slot-button" aria-label="Delete slot" (click)="cancelSlot(i)">
                        <img src="./../../assets/img/delete.svg" class="delete-slot-icon" alt="" />
                      </button>
                      <!--<div style="margin-left:30px" *ngIf="slot.value[0].status==='Cancelled'" >Slot Cancelled</div>-->
                      <div *ngIf="showConfirmationIndex === i" class="confirmation-popup">
                        <p>Are you sure you want to cancel this slot?</p>
                        <button class="pop-up-btn-white" (click)="confirmAction(slot.value[0])">Yes</button>
                        <button class="pop-up-btn-blue" style="margin-left: 20px;" (click)="cancelAction()">No</button>
                      </div>
                    </div>

                  </div>
                  <div class="row bookedSlotsFieldName slot-date-time-price-row">
                    <div class="col-12 slot-date-time-price">
                      <span>{{ getFormattedDate(slot.value[0].date) }}</span>
                      <span>{{ convertTo12HourFormat(slot.value[0].startTime) }} : {{
                        convertTo12HourFormat(slot.value[0].endTime) }}</span>
                      <span>Rs {{slot.value[0].amount}}</span>
                      <ng-container *ngIf="normalizeStatus(bookingStatus) !== 'failed'">
                        <span class="slot-status" *ngIf="slot.value[0].status === 'Booked'" style="color: green;">{{slot.value[0].status}}</span>
                        <span class="slot-status" *ngIf="slot.value[0].status === 'Cancelled'" style="color: red;">{{slot.value[0].status}}</span>
                        <span class="slot-status" *ngIf="slot.value[0].status === 'WaitingForPayment'" style="color: orange;">{{slot.value[0].status}}</span>
                      </ng-container>
                    </div>
                    <div class="col-12" style="margin-top: 5px;">
                      <p *ngIf="slot.value[0].endDate" class="bookedSlotsFieldName">
                        End Date : {{ slot.value[0].endDate | date:'dd MMM yyyy' }}
                      </p>
                    </div>

                  </div>
                </div>

                <!-- AddOns bought with this booking -->
                <ng-container *ngIf="addOnsBooked.length > 0">
                  <h6 class="descriptionHeader" style="margin-top:20px;font-size: 0.9rem;">ADD-ON</h6>
                  <div class="transaction-addon-list">
                    <div class="transaction-addon-row" *ngFor="let addOn of addOnsBooked">
                      <div class="transaction-addon-description">
                        <strong>{{addOn.productName}}</strong>
                        <span>
                          <ng-container *ngIf="addOn.quantity != null; else missingAddOnQuantity">
                            {{addOn.quantity}} ×
                          </ng-container>
                          <ng-template #missingAddOnQuantity>Qty not recorded ×</ng-template>
                          <ng-container *ngIf="addOn.unitPrice != null || addOn.quantity > 0; else missingAddOnPrice">Rs {{ (addOn.unitPrice ?? addOn.amount / addOn.quantity) | number:'1.2-2' }}</ng-container>
                          <ng-template #missingAddOnPrice>Rate not recorded</ng-template>
                        </span>
                      </div>
                      <strong class="transaction-addon-amount">Rs {{ addOn.amount | number:'1.2-2' }}</strong>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">

          <!--<button type="button" class="pop-up-btn-white" *ngIf="bookingStatus === 'Booked'" (click)="cancelBooking()">Cancel Booking</button>-->
          <button type="button" class="pop-up-btn-blue" *ngIf="canMarkAsPaid()"
            (click)="markAsPaid()">Mark as Paid</button>
          <button type="button" class="pop-up-btn-white" *ngIf="canCancelBooking()"
            (click)="cancelBooking()">Cancel Booking</button>
          <button type="button" class="pop-up-btn-blue" style="margin-left: 30px;" (click)="hideModal()">Close</button>
        </div>

      </div>
    </div>
  </div>
</div>
<router-outlet></router-outlet>
